import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import { axiosInstance } from '@appblocks/frontend/client/utils';


const FirmwareReleasesModal = ({
    showFirmwareModal,
    onClose,
    onFirmwareSelect,
    appId,
}) => {
    const [firmwareURL, setFirmwareURL] = useState('');
    const [projectName, setProjectName] = useState('');
    const [firmwareVersions, setFirmwareVersions] = useState([]);

    const getFirmwareVersions = async () => {
        if (!appId) {
            return;
        }
        try {
            const response = await axiosInstance.get(`${process.env.API_URL}/api/projects/${appId}/versions`);
            const versions = response.data.data.reverse().filter(version => version.url);
            if (versions.length > 0) {
                setProjectName(versions[0].name);
            }
            setFirmwareVersions(versions);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (showFirmwareModal) {
            getFirmwareVersions();
        }
    }, [showFirmwareModal]);

    return (
        <Modal
            show={showFirmwareModal}
            onHide={() => onClose()}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {projectName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    onSelect={() => {
                        setFirmwareURL('');
                    }}
                >
                    <Tab eventKey={0} title="Firmware Snapshots" key={0}>
                        {firmwareVersions.length > 0 ? (
                            <Table
                                striped
                                bordered
                                hover
                                style={{
                                    tableLayout: 'fixed',
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th className="col">Name</th>
                                        <th className="col">Description</th>
                                        <th className="col">Created At</th>
                                        <th className="col">Firmware</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {firmwareVersions.map(version => (
                                        <tr key={version.versionCode}>
                                            <td>
                                                <div>
                                                    {version.versionCode}
                                                </div>
                                            </td>
                                            <td>
                                                {version.versionDescription}
                                            </td>
                                            <td>
                                                <OverlayTrigger overlay={(
                                                    <Tooltip>
                                                        {moment(version.createdAt)
                                                            .toLocaleString()}
                                                    </Tooltip>
                                                )}
                                                >
                                                    <span>
                                                        {
                                                            moment(
                                                                version.createdAt,
                                                            ).fromNow()
                                                        }
                                                    </span>
                                                </OverlayTrigger>


                                            </td>
                                            <td>
                                                {version.url && (
                                                    <Button
                                                        className="table-actions"
                                                        variant="primary"
                                                        onClick={() => onFirmwareSelect(version)}
                                                    >
                                                        Select
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="mt-2 mb-2 ms-2">
                                No snapshots
                            </div>
                        )}
                    </Tab>
                    {/* <Tab eventKey={1} title="Advanced" key={1}>
                        <Form.Group className="mb-2 mt-2">
                            <Form.Label>TCU File URL</Form.Label>
                            <Form.Control
                                type="text"
                                value={firmwareURL}
                                placeholder="https://example.com/firmware.tcu"
                                onChange={
                                    e => setFirmwareURL(e.target.value)}
                            />
                        </Form.Group>
                        <Button
                            variant="primary"
                            onClick={() => onFirmwareSelect(firmwareURL)}
                        >
                            Upload
                        </Button>
                    </Tab> */}
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => onClose()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FirmwareReleasesModal;
